import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="qn-seccion" aria-label={seccion.titulo}>
      <div className="qn-seccion-interior">
        <EncabezadoSeccion p="qn" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="qn-titulo-itinerario" />
        <Reveal>
          <ul className="qn-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="qn-itinerario-item" key={i} data-testid={`qn-itinerario-item-${i}`}>
                  <span className="qn-itinerario-punto" aria-hidden="true" />
                  <span className="qn-itinerario-hora">{item.hora}</span>
                  <div className="qn-itinerario-cuerpo">
                    <h3 className="qn-itinerario-titulo">
                      <Icono size={16} strokeWidth={1.5} />
                      {item.titulo}
                    </h3>
                    {item.descripcion && <p className="qn-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
